import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';
import CombinationOptions from './components/combination-options';

class SinglegameForcedStacking extends Component {
    onClick(use) {
        this.props.dispatch(Action.do('useStacking', !use));
    }

    render() {
        let {sportConfig, stacking} = this.props;

        if (!sportConfig.isReady()) {
            return null;
        }

        return (
            <div className={`advanced-filter${stacking.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={() => ::this.onClick(stacking.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable Team Forced Stacking
                    </button>
                    <button
                        type="button"
                        onClick={() => ::this.onClick(stacking.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Enable Team Forced Stacking
                    </button>
                </div>

                <div className="white-box">
                    <h2 className="mb15">Team Forced Stack Rules</h2>
                    <CombinationOptions />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, singlegameForcedStacking} = state;

    return {
        sportConfig,
        stacking: singlegameForcedStacking.settings,
    };
}

export default connect(mapStatesToProps)(SinglegameForcedStacking);
